/* =========================================================
   LISITA — Dot indicators per caroselli mobile
   Si applica a .lisita-trust__grid e .lisita-categories__grid
   ========================================================= */
(function () {
  var SELECTORS = ['.lisita-trust__grid', '.lisita-categories__grid'];
  var MOBILE_QUERY = '(max-width: 749px)';

  function clearDots() {
    document.querySelectorAll('.lisita-dots').forEach(function (el) {
      el.remove();
    });
  }

  function buildDots(grid) {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;

    var cards = Array.prototype.filter.call(grid.children, function (c) {
      return c.nodeType === 1;
    });
    if (cards.length < 2) return;

    // Calcola n. pagine visibili = ceil(scrollWidth / clientWidth)
    var pages = Math.max(1, Math.ceil(grid.scrollWidth / grid.clientWidth));
    if (pages < 2) return;

    var dotsContainer = document.createElement('div');
    dotsContainer.className = 'lisita-dots';
    dotsContainer.setAttribute('role', 'tablist');
    dotsContainer.setAttribute('aria-label', 'Indicatori carosello');

    for (var i = 0; i < pages; i++) {
      var dot = document.createElement('button');
      dot.className = 'lisita-dot' + (i === 0 ? ' is-active' : '');
      dot.type = 'button';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', 'Pagina ' + (i + 1) + ' di ' + pages);
      dot.dataset.page = i;
      (function (idx) {
        dot.addEventListener('click', function () {
          grid.scrollTo({
            left: idx * grid.clientWidth,
            behavior: 'smooth'
          });
        });
      })(i);
      dotsContainer.appendChild(dot);
    }

    grid.parentNode.insertBefore(dotsContainer, grid.nextSibling);

    function updateActive() {
      var current = Math.round(grid.scrollLeft / grid.clientWidth);
      Array.prototype.forEach.call(dotsContainer.children, function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    grid.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  }

  function init() {
    clearDots();
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(buildDots);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on resize (mobile→desktop o orientation change)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 200);
  });

  // Re-init quando l'admin Shopify editor ridisegna sezioni
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:reorder', init);
  }
})();
